import { useEffect, useRef, useState } from 'react';
import { Card, Button, Stack } from 'react-bootstrap';
import { IMAGE_BASE_URL, IMAGE_URL } from '../../../../config';
import './FoodItemCard.css';
import { usePermission } from '../../../../hooks/usePermission';
import { PERMISSIONS } from '../../../../permissions/permissions';
import { ReadMore } from '../../../../components/ReadMore';
import { MdDeleteOutline, MdEdit } from 'react-icons/md';

export function FoodItemCard({ item, currentLanguage, categoryDetails, onEdit, onDelete }) {
  const translation = item.translationsMap?.[currentLanguage] || item.translationsMap?.['en'] || {};

  const canEditFood = usePermission(PERMISSIONS.FOOD_ITEMS.UPDATE);
  const canDeleteFood = usePermission(PERMISSIONS.FOOD_ITEMS.DELETE);

  const category = categoryDetails?.[item.foodSectionId]?.translationsMap?.[currentLanguage] || {};

  const descRef = useRef(null);
  const [expanded, setExpanded] = useState(false);
  const [showMore, setShowMore] = useState(false);

  useEffect(() => {
    if (!descRef.current) return;

    const el = descRef.current;
    el.classList.remove('clamped');
    const full = el.scrollHeight;
    el.classList.add('clamped');
    const clamp = el.clientHeight;

    setShowMore(full > clamp);
  }, [translation.description]);

  return (
    <Card className="food-item-card shadow-sm border-0">
      {/* Image */}
      <div className="image-container">
        {item.foodDietary && (
          <div className="dietary-badge-container">
            {/* <span className="dietary-badge">{item.foodDietary}</span> */}
            <img style={{ width: '20px' }} src={`${IMAGE_URL}/${item.foodDietary == 'Vegetarian' ? 'veg.jpg' : 'no-veg.png'}`} alt="" />
          </div>
        )}

        <img
          src={item.image ? `${IMAGE_BASE_URL}${item.image}` : 'https://via.placeholder.com/400x220?text=No+Image'}
          alt={translation.name}
          className="card-image"
          onError={(e) => {
            e.target.src = 'https://via.placeholder.com/400x220?text=No+Image';
            e.target.style.objectFit = 'contain';
          }}
        />
      </div>

      {/* Content */}
      <Card.Body className="p-4 d-flex flex-column">
        {/* Title */}
        <div className="mb-3">
          <h5 className="food-title fw-medium mb-2">{translation.name}</h5>
          <div className="orange-accent-line mb-2" />
          <div className="category-text">{category.name}</div>
        </div>

        {/* Description */}
        {/* <div className="mb-3">
          <Card.Text ref={descRef} className={`food-description ${!expanded ? 'clamped' : ''}`}>
            {translation.description}
          </Card.Text>

          {showMore && (
            <button className="read-more-btn" onClick={() => setExpanded(!expanded)}>
              {expanded ? 'Read less' : 'Read more'}
            </button>
          )}
        </div> */}
        <ReadMore limit={90}>{translation.description}</ReadMore>

        {/* Price */}
        <div className="price-section mt-auto d-flex justify-content-between">
          <span className="price-amount mt-1">{item.basePrice} ₾</span>
          {canDeleteFood && canEditFood && (
            <Stack direction="horizontal" gap={2}>
              <Button
                variant="white"
                className="shadow-sm rounded-circle p-2 border-0"
                onClick={() => onEdit(item)}
                style={{ backgroundColor: '#fff', width: '38px', height: '38px' }}
              >
                <MdEdit size={20} style={{ color: 'var(--pc-sidebar-active-color)' }} />
              </Button>
              <Button
                variant="white"
                className="shadow-sm rounded-circle p-2 border-0"
                onClick={() => onDelete(item.id)}
                style={{ backgroundColor: '#fff', width: '38px', height: '38px' }}
              >
                <MdDeleteOutline size={20} className="text-danger" />
              </Button>
            </Stack>
          )}
        </div>

        {/* Actions */}
        {/* {canDeleteFood && canEditFood && (
          <div className="d-flex gap-3 mt-2">
            <Button className="action-btn edit-btn flex-fill" onClick={() => onEdit(item)}>
              Edit
            </Button>

            <Button className="action-btn delete-btn flex-fill" onClick={() => onDelete(item.id)}>
              Delete
            </Button>
          </div>
        )} */}
      </Card.Body>
    </Card>
  );
}
